import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@watkinslabs/watkinsx-components/dist/index.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
